"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
react_modal_1.default.setAppElement('#react-modal');
var Modal = function (_a) {
    var children = _a.children, className = _a.className, closeClassNames = _a.closeClassNames, _b = _a.overlayClassNames, overlayClassNames = _b === void 0 ? '' : _b, disableClose = _a.disableClose, handleClose = _a.handleClose, isOpen = _a.isOpen, style = _a.style;
    return (react_1.default.createElement(react_modal_1.default, { className: (0, classnames_1.default)(className, 'content'), isOpen: isOpen, onRequestClose: function () { return handleClose && handleClose(); }, overlayClassName: (0, classnames_1.default)('modal grid-y align-middle align-center', overlayClassNames), shouldCloseOnEsc: false, shouldCloseOnOverlayClick: !disableClose, style: style },
        !disableClose && (react_1.default.createElement("div", { className: 'position-absolute right-1 top-1', style: { zIndex: 80 } },
            react_1.default.createElement("a", { className: 'padding-1', onClick: handleClose },
                react_1.default.createElement("i", { className: closeClassNames || 'ss-delete h4' })))),
        children));
};
exports.default = Modal;
